export default __webpack_public_path__ + "navigation-examples-electronic-horizon-1200-475917c1e2e4333bef2236d7000a4db9.png";